import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CDSMask } from '@app/utils/cds-mask';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoService } from '@app/services/processo.service';


@Component({
  selector: 'app-atendimento',
  templateUrl: './atendimento.component.html'
})
export class AtendimentoComponent implements OnInit {


  minhaAgenda: MinhaAgenda = new MinhaAgenda();
  lstAdvogados: IdDescricao[];
  cdsMask: CDSMask = new CDSMask();
  lstErros = [];
  
  lstUnidades: IdDescricao[] = [];

  constructor(
    private route: ActivatedRoute,
    private processoService: ProcessoService,
    private consultasService: ConsultasService) {
  }

  ngOnInit() {
    const hoje = new Date();
    const horas = UtilitarioService.adicionaZero(hoje.getHours());
    const minutos = UtilitarioService.adicionaZero(hoje.getMinutes());

    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);

    this.minhaAgenda.DataAgendada = UtilitarioService.retornaDataAtualMaisDias(0);
    this.minhaAgenda.HoraInicioAgendada = horas + ':' + minutos;

    this.route.params.subscribe(
      (params: any) => {
        this.minhaAgenda.ClienteId = params['clienteid'];
      });

    this.route.parent.params.subscribe(
      (params: any) => {
        this.minhaAgenda.ProcessoId = params['id'];
      });

    this.consultasService.consultar('ADVOGADO').toPromise().then(data => this.lstAdvogados = data);

  }

  adicionar() {
    this.lstErros = [];
    
    if (!this.minhaAgenda.UsuarioId && !this.minhaAgenda.UnidadeId) {
      this.lstErros.push('É necessário selecionar pelo menos um advogado ou uma unidade.');
      return;
    }

    this.minhaAgenda.Atendimento = true;
    this.processoService.gravarAtendimento(this.minhaAgenda)
      .subscribe(
        () => { window.location.href = '#/agenda/atendimento'; },
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
        });
  }




}
